
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import moment from 'moment';
import { WEEKDAYS } from '@/util/constant';

interface Time {
  weekday: number;
  deliveryAt: string | null;
  deliveryAtMenu: false;
}

@Component
export default class DeliveryTime extends Vue {
  @Prop({ type: String, default: '' }) public title!: string;

  public $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };
  public hours: Time[] = [];

  get weekdays() {
    const days = WEEKDAYS(this.$i18n);

    return days.map((day, index) => {
      return { value: index, text: day };
    });
  }

  public addOpeningHour() {
    this.hours.push({
      weekday: 0,
      deliveryAt: null,
      deliveryAtMenu: false,
    });
  }

  public getHours() {
    return this.hours.map((h: Time) => {
      return {
        ...h,
        deliveryAt: this.getUtcTime(h.deliveryAt!),
      };
    });
  }

  public setHours(hours: Time[], overwrite: boolean = false): void {
    if (overwrite) {
      this.hours = [];
    }
    for (const hour of hours) {
      this.hours.push({
        weekday: hour.weekday,
        deliveryAtMenu: false,
        // @ts-ignore
        deliveryAt: this.toLocaleTime(hour.deliveryAt),
      });
    }
  }

  public getUtcTime(time: string): string | null {
    if (!moment(time, 'HH:mm').isValid()) {
      return null;
    }

    return moment(time, 'HH:mm').subtract(120, 'minutes').format('HH:mm');
  }

  public toLocaleTime(time: string): string | null {
    if (!moment(time, 'HH:mm').isValid()) {
      return null;
    }

    return moment(time, 'HH:mm').add(120, 'minutes').format('HH:mm');
  }

  public removeHour(item: Time) {
    this.hours.splice(this.hours.indexOf(item), 1);
  }

  public validate(): Promise<boolean> {
    return this.$refs.observer.validate();
  }
}
